export const PREVIEW_STORAGE_KEY = "preview_version_1.0";
